import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';

import { TipsService } from '../tips.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-tips-details',
  templateUrl: './tips-details.component.html',
  styleUrls: ['./tips-details.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class TipsDetailsComponent implements OnInit, OnDestroy {

	private slug: string;
	private inscription: Subscription;
	public data;

	constructor(private _service: TipsService,
				private _router: Router,
				private _activeRoute: ActivatedRoute,
				private _titleService: Title,
				private _meta: Meta) { }

	ngOnInit() {
		this.inscription = this._activeRoute.params.subscribe(
			(params: any) => {
				this.slug = params['slug'];
				if (this.slug) {
					this._service.getItem(this.slug)
					.subscribe(
						response => {
							this.data = response;
							this._titleService.setTitle( response['title'] + '- Hospital Veterinário Stolf');
							this._meta.addTag({
								name: 'title',
								content: response['seoTitle']
							});
							this._meta.addTag({
								name: 'description',
								content: response['seoDescription']
							});
						},
						error => {
							console.error ( error );
						}
					);
				} else {
					// 404 error
				}
			}
		);
	}

	formatDate(date) {
		let meses = [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro'
		  ];
		let str = date.substr(0, 10).split('-').reverse().join('/');
		let dias = ['domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
		let partes = str.split('/').map(Number);
		let data = new Date( partes[2], partes[1] - 1, partes[0]);
		let diaSemana = dias[data.getDay() % 7];
		let mes = meses[data.getMonth()];
		let ano = partes[2];
		return [data.getDate() + ' de ' + mes.toLowerCase() + ' de ' + ano].join(' ');
	}

	ngOnDestroy() {
		this.inscription.unsubscribe();
	}

}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/tips/tips-details/tips-details.component.ts